import React, { useEffect } from 'react'
import MassiveActions from './MassiveActions'
import Pagination from './Pagination'

import './styles.scss'

const Navigator = (props) => {
  const {
    checkResult, actionOptions, onChangeAction, resultActionOptions,
    onChangeMassiveAction, limit, totalResult, numberPage, isAllSelected,
    onApplyMassAction, loadingMassiveAction, resetMassiveAction
  } = props
  const pageCount = Math.ceil(totalResult / limit)

  useEffect(() => {
    if (numberPage > 0 && numberPage > pageCount - 1) onChangeMassiveAction('page', pageCount - 1)
  }, [pageCount])

  return (
    <div className='fixed-pagination'>
      <MassiveActions
        actionOptions={actionOptions}
        onChangeAction={onChangeAction}
        resultActionOptions={resultActionOptions}
        limit={limit}
        totalResult={totalResult}
        checkResult={checkResult}
        isAllSelected={isAllSelected}
        onApplyMassAction={onApplyMassAction}
        loadingMassiveAction={loadingMassiveAction}
        resetMassiveAction={resetMassiveAction}
      />
      {totalResult ? (
        <Pagination
          pageCount={pageCount}
          handlePageClick={onChangeMassiveAction}
          page={numberPage}
        />
      ) : null}
    </div>
  )
}

export default Navigator
